import React from "react";
import { Link } from "react-router-dom";
import { DropdownMenu, DropdownItem, UncontrolledDropdown } from "reactstrap";
import NameAvatar from "../../atoms/nameAvatar";
import T from "../../atoms/translate";

const AvatarMenu = (props) => (
  <UncontrolledDropdown inNavbar className="ml-auto avatar-menu">
    {/* <UncontrolledDropdown nav inNavbar> */}
    {/*TODO: hacer que la letra de la inicial venga del nombre
      por ahora será del email
     */}
    <NameAvatar name={props.email} className="avatar-menu-name" />
    <DropdownMenu right>
      <Link to="/account" className="dropdown-item py-2">
        <T i18nKey="cuenta" />
      </Link>
      <DropdownItem divider className="my-0" />
      {/* <DropdownItem>User settings</DropdownItem>
      <DropdownItem>Notification settings</DropdownItem>
      <DropdownItem divider />
      <DropdownItem>Documentation</DropdownItem>
      <DropdownItem divider /> */}
      <DropdownItem className="py-2" onClick={() => props.logout()}>
        <T i18nKey="logout" />
      </DropdownItem>
    </DropdownMenu>
  </UncontrolledDropdown>
);

// Title.defaultProps = {
//   className: '',
//   children: '',
// }

export default AvatarMenu;
